import { Spin } from 'antd'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'

const UploadItem = ({
  image,
  onRemove,
  onPreview,        // 👈 thêm
  type = 'image'    // image | video | image360
}) => {
  const canPreview = !image.uploading && image.url

  return (
    <div
      onClick={() => canPreview && onPreview?.(image)}
      style={{
        width: 80,
        height: 80,
        borderRadius: 8,
        overflow: 'hidden',
        border: '2px solid #e0e0e0',
        position: 'relative',
        background: '#f0f0f0',
        cursor: canPreview ? 'pointer' : 'default'
      }}
    >
      {/* PREVIEW */}
      {canPreview && (
        type === 'video' ? (
          <video
            src={image.url}
            muted
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <img
            src={image.url}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        )
      )}

      {/* LOADING */}
      {image.uploading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2
          }}
        >
          <Spin />
        </div>
      )}

      {/* PREVIEW ICON */}
      {canPreview && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.15)',
            opacity: 0,
            transition: '0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          className="upload-preview-mask"
        >
          <EyeOutlined style={{ color: '#fff', fontSize: 20 }} />
        </div>
      )}

      {/* REMOVE */}
      {!image.uploading && (
        <div
          onClick={(e) => {
            e.stopPropagation() // ❗ tránh mở preview
            onRemove()
          }}
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            cursor: 'pointer',
            background: 'rgba(0,0,0,0.45)',
            borderRadius: '50%',
            padding: 4,
            zIndex: 3
          }}
        >
          <DeleteOutlined style={{ color: '#fff', fontSize: 12 }} />
        </div>
      )}
    </div>
  )
}

export default UploadItem
